var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位技能:",
      "prop": "skill"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.skill)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入职位技能"
    },
    model: {
      value: (_vm.ruleForm.skill),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "skill", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.skill"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "熟练度:",
      "prop": "proficiency"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_SKILL_PROFICIENCY', _vm.ruleForm.proficiency))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择熟练度"
    },
    model: {
      value: (_vm.ruleForm.proficiency),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "proficiency", $$v)
      },
      expression: "ruleForm.proficiency"
    }
  }, _vm._l((_vm.selectMap.WB_SKILL_PROFICIENCY), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "使用时间:",
      "prop": "experience"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_SKILL_YEARS', _vm.ruleForm.experience))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择使用时间"
    },
    model: {
      value: (_vm.ruleForm.experience),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "experience", $$v)
      },
      expression: "ruleForm.experience"
    }
  }, _vm._l((_vm.selectMap.WB_SKILL_YEARS), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7332d2f7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/skill.vue
// module id = null
// module chunks = 